module.exports = __webpack_public_path__ + "static/img/5.f7766b95.jpg";